<template>
    <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18.47 60"
        :class="class"
        aria-hidden="true"
    >
    <path d="M0 0h18.4l.07 60a10 10 0 0 1-9.86-8.36Z" />
    </svg>
</template>
<script>
export default {
    props: {
        class: {
            type: String,
            default: ''
        }
    }
}
</script>